var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeguardedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2067 0.924136C14.9336 0.750867 14.6176 0.657201 14.2942 0.653668C13.9708 0.650135 13.6528 0.736874 13.376 0.904136L1.22669 8.2548C1.01022 8.38601 0.842611 8.58442 0.749428 8.81978C0.656244 9.05513 0.642604 9.31451 0.710586 9.55834C0.778569 9.80217 0.924443 10.0171 1.12596 10.1703C1.32747 10.3235 1.57356 10.4065 1.82669 10.4068H3.56536V23.7428H1.24536V26.0615H26.7534V23.7415H24.4347V10.4081H26.1734C26.4248 10.4088 26.6697 10.3264 26.871 10.1757C27.0723 10.025 27.2191 9.81287 27.2892 9.57139C27.3594 9.32992 27.3491 9.07218 27.2599 8.83708C27.1706 8.60198 27.0074 8.40229 26.7947 8.26814L15.208 0.924136H15.2067ZM22.18 8.08814L14.2694 3.0748L5.98136 8.08814H22.18ZM15.1587 10.4081H22.116V23.7415H15.16L15.1587 10.4081ZM5.88403 10.4081V23.7415H12.84V10.4081H5.88403Z",
    fill: "#7F84F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeguardedIcon);
export default __webpack_public_path__ + "static/media/safeguarded-icon.f1fc93aaf5bb99e99efca856bf949cf1.svg";
export { ForwardRef as ReactComponent };